<template>
  <router-view :key="$route.fullPath"/>
  <SpinnerModal :spinning="spinnerActive"></SpinnerModal>
  <notificationModal></notificationModal>
</template>

<script>
import {mapState} from "vuex"
import SpinnerModal from "@/modals/SpinnerModal"
import notificationModal from "@/modals/notificationModal"

export default {
  name: 'App',
  components: {
    SpinnerModal,
    notificationModal
  },
  computed: {
    ...mapState([
      'spinnerActive'
    ])
  }
}
</script>

<style lang="scss">
  @use '@/assets/sass/mybulma.scss';
</style>
